import type { Referential } from '@yescapa-dev/ysc-api-js/legacy'

export const useReferentialMap = <K extends keyof Referential['maps']>(key: MaybeRefOrGetter<K>) => {
  const { getReferentialMaps } = useReferentialStore()

  const map = computed(() => getReferentialMaps(toValue(key)))

  return { map }
}
